"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const detect_utils_1 = require("@/common/detect_utils");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = (0, styled_1.default)((_a) => {
    var { register } = _a, props = __rest(_a, ["register"]);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("input", Object.assign({}, register('email', {
        required: `${t('이메일을 입력해주세요')}`,
        pattern: { value: detect_utils_1.emailRegex, message: `${t('이메일을 정확히 입력해주세요')}` },
    }), { type: "email", placeholder: t('이메일을 입력하세요') }, props)));
}) `
  width: 100%;
  padding: 16px;
  border: 1px solid black;
  border-radius: 6px;
  margin-top: 60px;
  background-color: transparent;
  font-size: 14px;
  &:focus {
    border: 1px solid black !important;
  }
`;
